// WorkAbroadHero.js
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import ConsultationModal from '../ConsultationModal';

const WorkAbroadHero = () => {
  const [showConsultationModal, setShowConsultationModal] = useState(false);

  return (
    <section className="relative bg-white py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left Column - Content */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            {/* Tag */}
            <span className="inline-block bg-surface text-secondary text-sm font-light px-6 py-2 rounded-full mb-6">
              Work Abroad
            </span>

            {/* Heading */}
            <h1 className="text-4xl md:text-5xl font-semibold text-primary mb-6 leading-tight">
              Employer-Led Routes to Working Overseas
            </h1>

            {/* Subtext */}
            <p className="text-gray-600 text-base font-light leading-relaxed mb-6">
              Taking a job in another country is a professional move, not a quick one. It asks for planning, proof that you meet the criteria, and a route into employers who are actually hiring. Ivipass works with candidates who qualify, connecting them to roles overseas through the employer and recruitment partners we deal with, a structured screening stage, and preparation before any interview.
            </p>

            <p className="text-gray-600 text-base font-light leading-relaxed mb-8">
              Our approach is built on honesty about what is realistic, thorough preparation, and making sure you know what a stage involves before you commit to it.
            </p>

            {/* CTA Button */}
            <button
              onClick={() => setShowConsultationModal(true)}
              className="inline-block bg-primary hover:bg-primary-hover text-white font-normal text-base px-8 py-4 rounded-lg transition-colors"
            >
              Book an Eligibility Consultation
            </button>
          </motion.div>

          {/* Right Column - Image */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="relative"
          >
            <div className="relative h-[400px] md:h-[500px] rounded-lg overflow-hidden">
              <img
                src={require('../../assets/work-abroad-hero.jpg')}
                alt="Work Abroad"
                className="w-full h-full object-cover"
              />
            </div>
          </motion.div>
        </div>
      </div>

      {/* Consultation Modal */}
      <ConsultationModal 
        isOpen={showConsultationModal}
        onClose={() => setShowConsultationModal(false)}
        serviceType="work-abroad"
      />
    </section>
  );
};

export default WorkAbroadHero;
